import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { useAnalytics } from 'use-analytics';
import ConfirmModal from '../ConfirmModal';

const LoginRequestModal = ({ onCancel, actionName }) => {
  const router = useRouter();
  const { track } = useAnalytics();

  const handleLoginClick = () => {
    track('redirectToLogin_TripConfirmation_LoginModal');
    router.push(`/login?returnUrl=${encodeURIComponent(router.asPath)}`);
    onCancel();
  };

  return (
    <ConfirmModal
      onCancel={onCancel}
      onConfirm={handleLoginClick}
      okButtonLabel="Login"
      cancelButtonLabel="Close"
      event="Login requested"
      message={
        <>
          <div>
            <strong>Note:</strong> It looks like you don&apos;t have permission to {actionName}{' '}
            without login. Please log in to your account to proceed or reach out to our support team
            for assistance.
          </div>
        </>
      }
    />
  );
};

LoginRequestModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  actionName: PropTypes.string,
};

LoginRequestModal.defaultProps = {
  actionName: 'perform action',
};

export default LoginRequestModal;
